import _ from 'lodash';
import React, {Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';
import update from "immutability-helper";
//import moment from 'moment';

//- Material UI / Style
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import { getGlobalClasses } from '../../themes';

//containers
import AuthUserContainer from '../../containers/AuthUser';

//- UI / Form
import Grid from "@material-ui/core/Grid";
import Button from '@material-ui/core/Button';
import { green } from '@material-ui/core/colors';

//import SectionHeader from "../../components/SectionHeader";
//import CompanyDepartmentPicker from "../../components/advancedForm/CompanyDepartmentPicker";
import Note from "../../components/Note";
//import DownloadIcon from '@material-ui/icons/CloudDownload';
import SearchIcon from '@material-ui/icons/Search';
import CircularProgress from "@material-ui/core/CircularProgress";
import TmwCustomerSelect from "../../components/advancedForm/TmwCustomerSelect";
import localStorage from "../../libs/localStorage";
import TmwApi from "../../containers/Ticket/TmwApi";
import Table from "@material-ui/core/Table";
import EnhancedTableHead from "../../components/table/EnhancedTableHead";
import TableBody from "@material-ui/core/TableBody";
import {PureRecordRow, sortTable} from "../../libs/tableUtilities";
//import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import { sampleInvoiceResult } from './sampleTmwOrders';
import copyToClipboardSvg from "../../images/icons/copyToClipboard.svg";
import CheckIcon from "@material-ui/icons/Check";

import Popover from '@material-ui/core/Popover';
import UnbilledAddCommentDialog from "../../components/dialogs/UnbilledAddCommentDialog";
import TmwInvoiceStatusSelect from "../../components/advancedForm/TmwInvoiceStatusSelect";
import FormDatePicker from "../../components/form/FormDatePicker";
import TmwBillerSelect from "../../components/advancedForm/TmwBillerSelect";
import UserPicker from "../../components/advancedForm/UserPicker";
import FormCheckbox from "../../components/form/FormCheckbox";
import DownloadIcon from "@material-ui/icons/CloudDownload";
import WarningIconSvg from '../../images/icons/warningIcon.svg';

const USE_TEST_DATA = false;

const linkColor = '#137EC2';
const styles = (theme) => {
	return {
		...getGlobalClasses(theme),
		submitButton : {
			marginTop : 20,
			fontSize : 16,
			borderRadius : '100px',
			padding : '13px 45px',
			textTransform: 'uppercase',
			marginRight : 10,
		},
		icon : {
			paddingRight : 5,
		},
		oddRow : {
			backgroundColor : '#f9f9f9',
		},
		hasExceptionRow: {
			backgroundColor : '#ffe1d5',
		},
		linkedCells : {
			borderBottom : '1px dashed #f1f1f1',
			position : 'relative',
		},
		notLinked : {
			lineHeight : 1.4,
		},
		linkedOrders : {
			borderLeft: `2px solid ${linkColor}`,
			position: 'absolute',
			left : 4,
			top : '39%',
			height : 60,
			'&::before': {
				position: 'absolute',
				top : 0,
				left: -6,
				height: 10,
				width: 10,
				background: linkColor,
				content: '""',
				borderRadius: 5,
			},
			'&::after' : {
				position: 'absolute',
				top : 'auto',
				bottom: 0,
				left : -6,
				height: 10,
				width: 10,
				background: linkColor,
				content: '""',
				borderRadius: 5,
			}
		},
		resultsHere : {
			padding : 30,
			backgroundColor : '#f1f1f1',
			color : '#777',
			borderRadius : 10,
		},
		runningSearch : {
			paddingLeft : 20,
			display : 'flex',
			alignItems : 'center',
			fontSize : 18,
			color :  '#666',
		},
		copyToClipboardIcon: {
			display : 'inline-block',
			width : 20,
			height : 20,
			backgroundImage: `url('${copyToClipboardSvg}')`,
			backgroundPosition: 'center',
			backgroundSize: 'cover',
			verticalAlign: 'middle',
			marginLeft: 5,
			cursor : 'pointer',
		},
		snackbarSuccess: {
			backgroundColor: green[600],
		},
		snackbarIcon: {
			opacity: 0.9,
			marginRight: theme.spacing(1),		fontSize: 20,
		},
		snackbarMessage: {
			display: 'flex',
			alignItems: 'center',
		},
		moveNumber : {
			fontSize : 13,
			color : '#999',
		},
		popover: {
			pointerEvents: 'none',
		},
		noComments : {
			borderRadius: 4,
			fontSize: 13,
			padding: '2px 9px',
			minWidth: 'auto',
			color : '#888',
			marginRight : 3,
		},
		hasComments : {
			borderRadius: 4,
			fontSize: 13,
			padding: '2px 9px',
			minWidth: 'auto',
			fontWeight : 600,
			marginRight : 3,
		},
		commentsContainer : {
			padding : 20,
		},
		commentContainer : {
			borderBottom : '1px solid #eee',
			marginBottom : 5,
			paddingBottom : 5,
		},
		commentDateTime : {
			fontSize : '80%',
			color : '#666',
		},
		smallWarningIcon : {
			display: 'inline-block',
			width: 28,
			height: 28,
			backgroundImage: `url('${WarningIconSvg}')`,
			backgroundPosition: 'center',
			backgroundSize: 'cover',
			verticalAlign: 'middle',
			marginRight : 0,
			marginLeft : 0,
			marginTop : -6,
		},
	};
};

class InvoiceSearch extends Component {
	constructor(props) {
		super(props);
		let billToCustomerIds = localStorage.getItem(this.getStorageKey('billToCustomerIds')) || [];
		let invoiceStatuses = localStorage.getItem(this.getStorageKey('invoiceStatuses')) || [];
		let lastUpdatedByUsers = localStorage.getItem(this.getStorageKey('lastUpdatedByUsers')) || [];
		let searchOnMount = false;

		let afterDate = moment().subtract(3, 'months').format('YYYY-MM-DD');
		if (_.get(this.props, 'match.params.afterDate')) {
			afterDate = _.get(this.props, 'match.params.afterDate');
			searchOnMount = true;
		}

		let beforeDate = moment().format('YYYY-MM-DD');
		if (_.get(this.props, 'match.params.beforeDate')) {
			beforeDate = _.get(this.props, 'match.params.beforeDate');
			searchOnMount = true;
		}

		const invoiceStatus = _.get(this.props, 'match.params.invoiceStatus');
		if (invoiceStatus) {
			invoiceStatuses = [invoiceStatus];
			searchOnMount = true;
		}

		const lastUpdatedBy = _.get(this.props, 'match.params.lastUpdatedBy');
		if (lastUpdatedBy) {
			lastUpdatedByUsers = [lastUpdatedBy];
			searchOnMount = true;
		}

		const billTo = _.get(this.props, 'match.params.billTo');
		if (billTo) {
			billToCustomerIds = [billTo];
			searchOnMount = true;
		}

		this.state = {
			afterDate,
			beforeDate,
			billToCustomerIds,
			invoiceStatuses,
			lastUpdatedByUsers,

			formFieldError: {},
			order: 'asc',
			orderBy: 'tmwOrderId',
			isSearching : false,

			commentPopoverIsOpen : false,
			commentPopoverAnchor : undefined,
			popoverComments : [],
			refreshId : 1,
			searchOnMount,

			//- TODO TESTING
			commentingOnTmwOrder : null,
		};
	}

	componentDidMount() {
		if (this.state.searchOnMount) {

			if (USE_TEST_DATA) {
				this.formatSearchResults({
					searchResult: sampleInvoiceResult,
				});
			} else {
				this.handleSearch();
			}
		}
	}

	getStorageKey(key) {
		return `/invoiceSearch-${key}`;
	}

	componentDidUpdate(prevProps, prevState, snapShot) {
	}

	//- Path is always a string
	//- value is never an event (value.target)
	onChange = (value, path, error) => {
		const arrayPath = _.toPath(path);
		const basePath = _.head(arrayPath);
		let base = this.state[basePath];
		let newState = {};

		if (_.isArray(base) || _.isObject(base)) {

			if (arrayPath.length > 1) {
				base = _.cloneDeep(base);
				_.set(base, arrayPath.slice(1), value);
				newState[basePath] = base;
			} else {
				newState[basePath] = value;
			}
		} else {
			newState[basePath] = value;
		}

		//- Clear any errors on the path
		let formFieldError = Object.assign({}, this.state.formFieldError);

		if (error) {
			formFieldError[path] = error;
		} else {
			delete formFieldError[path];
		}
		newState.formFieldError = formFieldError;

		if (
			path === 'billToCustomerIds'
			|| path === 'invoiceStatuses'
			|| path === 'lastUpdatedByUsers'
		) {
			localStorage.setItem(this.getStorageKey(path), value);
		}
		this.setState(newState);
	};

	getApiParams = () => {
		const { accessToken } = this.props;
		const {
			invoiceStatuses,
			includeXfrStatus,
			lastUpdatedByUsers,
			billToCustomerIds,
			driverName,
			afterDate,
			beforeDate,
		} = this.state;

		return {
			accessToken,
			invoiceStatuses,
			includeXfrStatus,
			lastUpdatedByUsers,
			billToCustomerIds,
			driverName,
			afterDate,
			beforeDate,
		}
	};

	handleSearch = () => {
		const {
			searchTmwInvoices,
			showErrors,
		} = this.props;

		const formFieldError = {};
		const requiredFields = [
			{path: 'billToCustomerIds', label: 'Bill to customers'},
		];

		requiredFields.forEach(({path, label})=> {
			if (!this.state[path]) {
				formFieldError[path] = `${label} is required`;
			}
		});

		const {
			includeXfrStatus,
			afterDate,
			beforeDate,
		} = this.state;

		if (includeXfrStatus) {
			const diff = moment(beforeDate).diff(moment(afterDate), 'days');
			if (diff > 14) {
				formFieldError.includeXfrStatus = `Max 14 date range supported. You have ${diff} days`;
				formFieldError.beforeDate = formFieldError.afterDate = `Max 14 date range when using Include Transfer Status`;
			}
		}

		//- Get all the values and do individual checks
		if (_.keys(formFieldError).length) {
			this.setState({formFieldError});
			showErrors(_.values(formFieldError));
			return;
		}

		const params = this.getApiParams();
		this.setState({
			isSearching: true,
		});

		searchTmwInvoices({
			params,
			callback : (err, r) => {
				this.setState({isSearching: false});
				if (err) {
					return showErrors((_.isArray(err)) ? err : [err]);
				}
				this.formatSearchResults({
					searchResult : r,
				});
			}
		});
	};

	formatCommentsByTmwOrderId = ({ apiResult }) => {
		const userMap = _.keyBy(
			_.get(apiResult, 'collections.userCollection', []),
			'userId'
		);

		const commentsByTmwOrderId = {};
		const allComments = _.get(apiResult, 'collections.tmwOrderCommentCollection', []);
		_.orderBy(allComments, 'dateCreated', 'asc').forEach(comment => {
			const { tmwOrderId, dateCreated, createdByUserId } = comment;
			const user = userMap[createdByUserId] || { firstName : 'Unknown' };

			comment.userDisplay = `${user.firstName} ${user.lastName}`;
			comment.dateTimeFormatted = moment(dateCreated).format('M/D h:mm a');

			if (!commentsByTmwOrderId[tmwOrderId]) {
				commentsByTmwOrderId[tmwOrderId] = [];
			}
			commentsByTmwOrderId[tmwOrderId].push(comment);
		});
		return commentsByTmwOrderId;
	};

	formatSearchResults = ({ searchResult }) => {
		const tmwInvoices = _.get(searchResult, 'tmwInvoices', []);

		const commentsByTmwOrderId = this.formatCommentsByTmwOrderId({
			apiResult : searchResult,
		});

		const ordersGroupByMoveNumber = {};
		tmwInvoices.forEach(tmwInvoice => {
			const { moveNumber } = tmwInvoice;

			if (!ordersGroupByMoveNumber[moveNumber]) {
				ordersGroupByMoveNumber[moveNumber] = [];
			}
			ordersGroupByMoveNumber[moveNumber].push(tmwInvoice);

			const shipDateDisplay = moment(tmwInvoice.shipDate).format('M/D h:mm a');
			const completionDateDisplay = moment(tmwInvoice.completionDate).format('M/D h:mm a');
			tmwInvoice.shipDeliveryDate = (
				<div>
					<div>{shipDateDisplay}</div>
					<div>{completionDateDisplay}</div>
				</div>
			);

			tmwInvoice.driverDivisionDisplay = (<div>
				<div>{tmwInvoice.driverName}</div>
				<div>{tmwInvoice.division}</div>
			</div>);


			tmwInvoice.billToConsignee = (<div>
				<div>{tmwInvoice.billToCompany}</div>
				<div>{tmwInvoice.consigneeCompany}</div>
			</div>);

			/*
			const { bolNumber, sidNumber, customerRef } = tmwInvoice;
			tmwInvoice.refDisplay = (<div>
				{(!!bolNumber) && <div>BOL : {bolNumber}</div>}
				{(!!sidNumber) && <div>SID : {sidNumber}</div>}
				{(!!customerRef) && <div>CUST : {customerRef}</div>}
			</div>);
			tmwInvoice.refSort = (bolNumber) ? bolNumber
				: (customerRef) ? customerRef
					: (sidNumber) ? sidNumber : '';
			*/

			tmwInvoice.hasSplitDisplay = (tmwInvoice.splitCount >= 2)  ? <CheckIcon />  : '-';
			tmwInvoice.hasStopDisplay = (tmwInvoice.stopCount >= 1)  ? <CheckIcon />  : '-';

			//- comments
			tmwInvoice.tmwOrderComments = commentsByTmwOrderId[tmwInvoice.tmwOrderId] || [];
		});

		const searchResultTmwOrders = [];
		_.values(ordersGroupByMoveNumber).forEach(rows => {
			const mainTmwOrder = rows.pop();
			if (!_.isEmpty(rows)) {
				mainTmwOrder.linkedTmwOrders = rows;
			}
			searchResultTmwOrders.push(mainTmwOrder);
		});

		this.setState({
			searchResultTmwOrders,
			savingStatus: 'done',
		});
	};

	getInputProps = (path, defaultValue) => {
		return {
			key : path,
			path,
			value  : this.getValue(path, defaultValue),
			checked  : this.getValue(path, defaultValue),
			error : this.getError(path),
			onChange : this.onChange,
			gridProps : { md : 12 },
		};
	};

	getValue  = (path, defaultValue) => {
		const _d = (_.isUndefined(defaultValue)) ? '' : defaultValue;
		return _.get(this.state, path, _d);
	};

	getError = (path) => {
		return _.get(this.state.formFieldError, path);
	};

	render () {
		const {
			classes
		} = this.props;

		const {
			isSearching,
			searchResultTmwOrders,
		} = this.state;

		const { commentingOnTmwOrder} = this.state;

		const params = this.getApiParams();

		params.downloadCsv = true;
		const request = {
			method: 'tmw.invoice.search',
			params
		};
		const downloadUrl = `/api?request=${JSON.stringify(request)}`;

		return (<form>
			<Paper className={classes.globalMainPaper} style={{minHeight : 500}}>
				<div className={classes.globalMainHeadline}>TMW Invoice Search</div>

				<Grid spacing={2} container>
					<Grid item xs={12} sm={11} md={10} lg={8}>
						<Grid spacing={2} container>

							<Grid item xs={12}>
								<Note type={'info'}>
									Page will remember your settings between visits
								</Note>
							</Grid>

							<TmwInvoiceStatusSelect
								{...this.getInputProps('invoiceStatuses')}
								label={'Invoice Statuses (leave empty for all)'}
							/>

							<Grid item xs={12}>
								<FormCheckbox
									{...this.getInputProps('includeXfrStatus', false)}
									label={'Include Invoices in Transfer (XFR) Status'}
								/>
								<div style={{fontSize : 14, color : '#555', padding: 5, paddingLeft : 0}}>
									<strong>Important</strong> : Use this to help lookup previously processed invoices,
									but use an appropriate date range and bill to customer selection as this may
									return a very large number of records and slow the system down.
									Limited to a 2 week max range.
								</div>
							</Grid>


							<TmwBillerSelect
								{...this.getInputProps('lastUpdatedByUsers')}
								label={'Last Updated By (leave empty for all)'}
							/>

							<TmwCustomerSelect
								{...this.getInputProps('billToCustomerIds')}
								label={'Bill To Customer (leave empty for all)'}
							/>

							<UserPicker
								{...this.getInputProps('driverName')}
								label={'Driver'}
								useGeoTabNameAsValue={true}
							/>

							<FormDatePicker
								{...this.getInputProps('afterDate')}
								label='After date'
								format={'M/D/YYYY'}
								gridProps={{md:6}}
							/>

							<FormDatePicker
								{...this.getInputProps('beforeDate')}
								label='Before date'
								format={'M/D/YYYY'}
								gridProps={{md:6}}
							/>

							<Grid item xs={12} style={{padding : '20px 0px', display : 'flex'}}>
								<Button
									onClick={this.handleSearch}
									variant="contained"
									color="primary"
									className={classes.submitButton}
								>
									<SearchIcon className={classes.icon} />
									Search
								</Button>

								<a
									href={downloadUrl}
									style={{textDecoration: 'none', paddingRight : 5}}
									target="_blank" rel='noreferrer noopener'
								>
									<Button
										variant="contained"
										color="primary"
										className={classes.submitButton}
									>
										<DownloadIcon className={classes.icon} />
										Search & Download
									</Button>
								</a>

								{isSearching &&
								<div className={classes.runningSearch}>
									<CircularProgress/>
									<span style={{paddingLeft: 10, paddingTop : 10}}>Searching...</span>
								</div>
								}

							</Grid>
						</Grid>
					</Grid>
				</Grid>
			</Paper>

			<Paper className={classes.globalMainPaper}>
				{_.isUndefined(searchResultTmwOrders) &&
				<div className={classes.resultsHere}>
					Results here
				</div>
				}
				{!_.isUndefined(searchResultTmwOrders) &&
				this.renderResults()
				}
			</Paper>

			<Popover
				id="comment-popover"
				className={classes.popover}
				classes={{
					paper: classes.paper,
				}}
				open={!!this.state.commentPopoverAnchor}
				anchorEl={this.state.commentPopoverAnchor}
				anchorOrigin={{
					vertical: 'bottom',
					horizontal: 'left',
				}}
				transformOrigin={{
					vertical: 'top',
					horizontal: 'left',
				}}
				onClose={this.state.handleCommentPopoverClose}
				disableRestoreFocus
			>
				<div className={classes.commentsContainer}>
					{this.state.popoverComments.map(comment => {
						const { tmwOrderCommentId, commentText, userDisplay, dateTimeFormatted} = comment;
						return (
							<div key={tmwOrderCommentId} className={classes.commentContainer}>
								<div style={{whiteSpace: 'pre-line'}}><strong>{userDisplay} </strong>said "{commentText}"</div>
								<div className={classes.commentDateTime}>{dateTimeFormatted}</div>
							</div>
						);
					})}
				</div>
			</Popover>

			<Popover
				id="exception-popover"
				className={classes.popover}
				classes={{
					paper: classes.paper,
				}}
				open={!!this.state.exceptionPopoverAnchor}
				anchorEl={this.state.exceptionPopoverAnchor}
				anchorOrigin={{
					vertical: 'bottom',
					horizontal: 'left',
				}}
				transformOrigin={{
					vertical: 'top',
					horizontal: 'left',
				}}
				onClose={this.state.handleExceptionPopoverClose}
				disableRestoreFocus
			>
				<div className={classes.commentsContainer}>
					{this.state.popoverException}
				</div>
			</Popover>

			<UnbilledAddCommentDialog
				open={Boolean(commentingOnTmwOrder)}
				onClose={this.handleCloseCommentDialog}
				tmwOrder={commentingOnTmwOrder}
				afterSave={this.afterSaveComment}
			/>

		</form>);
	}

	afterSaveComment = ({ apiResult }) => {

		const { searchResultTmwOrders } = this.state;
		const commentsByTmwOrderId = this.formatCommentsByTmwOrderId({
			apiResult,
		});

		const newComment = _.first(_.first(_.values(commentsByTmwOrderId)));
		if (!newComment) {
			return console.error('Could not find newComment', commentsByTmwOrderId, apiResult);
		}

		const { tmwOrderId } = newComment;
		const currentIndex = _.findIndex(searchResultTmwOrders, { tmwOrderId });

		if (currentIndex === -1) {
			console.error('Could not find order to add comment to',tmwOrderId,searchResultTmwOrders);
			return;
		}

		const newSearchResultTmwOrders = update(searchResultTmwOrders, {
			[currentIndex] : {
				tmwOrderComments : { $push : [newComment] }
			}
		});
		this.setState({
			searchResultTmwOrders : newSearchResultTmwOrders,
			refreshId : this.state.refreshId + 1,
		});
	};

	handleAddComment = (order) => {
		this.setState({commentingOnTmwOrder : order });
	};
	handleCloseCommentDialog  = () => {
		this.setState({ commentingOnTmwOrder : null});
	};

	handleCommentPopoverOpen = (event, tmwOrderComments) => {
		this.setState({
			popoverComments	: tmwOrderComments,
			commentPopoverAnchor : event.currentTarget
		});
	};
	handleCommentPopoverClose = () => {
		this.setState({ commentPopoverAnchor : null });
	};

	handleExceptionPopoverOpen = (event, exceptionLabel) => {
		this.setState({
			popoverException: exceptionLabel,
			exceptionPopoverAnchor : event.currentTarget
		});
	};
	handleExceptionPopoverClose = () => {
		this.setState({ exceptionPopoverAnchor : null });
	};

	handleSort = (orderBy) => {
		let order = 'desc';
		if (this.state.orderBy === orderBy && this.state.order === 'desc') {
			order = 'asc';
		}
		this.setState({ order : order, orderBy : orderBy });
	};

	renderResults = () => {
		const { classes } = this.props;
		const { order, orderBy, searchResultTmwOrders } = this.state;

		const columns = [{
			id: 'tmwInvoiceId',
			label: 'TMW Invoice #',
		}, {
			id: 'tmwOrderId',
			label: 'TMW Order #',
		}, {
			id: 'shipDate',
			labels : ['Ship Date', 'Delivery Date'],
		}, {
			id: 'terminal',
			label: 'Terminal',
		}, {
			id: 'bolNumber',
			label : 'BOL #'
		}, {
			id: 'billTo',
			labels : ['Bill To', 'Consignee (Site)'],
		}, {
			id: 'division',
			labels : ['Driver', 'Division'],
		}, {
			id: 'invoiceStatus',
			label: 'Invoice Statuses',
		}, {
			id: 'lastUpdatedBy',
			label: 'Last Updated By',
		}, {
			id: 'exceptionLabel',
			label: 'X',
		}, {
			id: 'commentCount',
			label: 'Comments',
		}];

		const rows = sortTable({
			rows : searchResultTmwOrders,
			order,
			orderBy,
		});


		return (
			<Table size='small' className={classes.table}>
				<EnhancedTableHead
					columns={columns}
					order={order}
					orderBy={orderBy}
					onRequestSort={this.handleSort}
				/>
				<TableBody>
					{rows.map((row, i) => {
						let rowClass = (i % 2) ? classes.oddRow : null;

						const { exceptionLabel } = row;
						if (exceptionLabel) {
							rowClass = classes.hasExceptionRow;
						}


						let allOrders = [row];
						if (!_.isEmpty(row.linkedTmwOrders)) {
							allOrders = allOrders.concat(row.linkedTmwOrders);
						}

						return allOrders.map((order, i) => {

							let showLink = false;
							let cellClass = classes.notLinked;
							if (allOrders.length > 1 && i !== allOrders.length - 1) {
								cellClass = classes.linkedCells;
								showLink = true;
							}

							let commentDisplay;
							const { tmwOrderComments } = order;
							if (_.isEmpty(tmwOrderComments)) {
								commentDisplay = (
									<div>
										<Button size="small" variant="outlined" className={classes.noComments} disabled>
											0
										</Button>
									</div>
								);
							} else {
								commentDisplay = (
									<div
										aria-haspopup="true"
										onMouseEnter={(event) => {
											this.handleCommentPopoverOpen(event, tmwOrderComments);
										}}
										onMouseLeave={this.handleCommentPopoverClose}
									>
										<Button
											size="small" variant="outlined" color="primary"
											className={classes.hasComments}
										>
											{tmwOrderComments.length}
										</Button>
									</div>
								);
							}

							let exceptionDisplay = '';
							if (exceptionLabel) {
								exceptionDisplay = (<div
									onMouseEnter={(event) => {
										this.handleExceptionPopoverOpen(event, exceptionLabel);
									}}
									onMouseLeave={this.handleExceptionPopoverClose}
								>
									<span className={classes.smallWarningIcon}/>
								</div>);
							}

							return (
								<PureRecordRow
									hover
									className={rowClass}
									key={order.tmwOrderId}
									refreshId={this.state.refreshId}
								>
									<TableCell className={cellClass}>{order.invoiceNumber}</TableCell>
									<TableCell className={cellClass}>
										<div style={{display : 'flex'}}>
											{showLink && <div className={classes.linkedOrders} />}
											<div>
												<div>{order.tmwOrderId}</div>
											</div>
										</div>
									</TableCell>

									<TableCell className={cellClass}>{order.shipDeliveryDate}</TableCell>
									<TableCell className={cellClass}>{order.terminal}</TableCell>
									<TableCell className={cellClass}>{order.bolNumber}</TableCell>
									<TableCell className={cellClass}>{order.billToConsignee}</TableCell>
									<TableCell className={cellClass}>{order.driverDivisionDisplay}</TableCell>
									<TableCell className={cellClass}>{order.invoiceStatus}</TableCell>
									<TableCell className={cellClass}>{order.lastUpdatedBy}</TableCell>
									<TableCell className={cellClass}>{exceptionDisplay}</TableCell>
									<TableCell className={cellClass} align="center" style={{whiteSpace: 'nowrap'}}>
										<div style={{display : 'flex', alignItems : 'center'}}>
											{commentDisplay}
											<Button
												className={classes.button}
												onClick={() => this.handleAddComment(order)}
											>
												Add
											</Button>
										</div>
									</TableCell>
								</PureRecordRow>
							);
						});

					})}
				</TableBody>
			</Table>
		);
	};
}

InvoiceSearch.propTypes = {
	searchTmwInvoices : PropTypes.func.isRequired,
	//userMap : PropTypes.object,

	showErrors : PropTypes.func.isRequired,
	authUser : PropTypes.object,
	classes: PropTypes.object.isRequired,
};

export default _.flow([
	withStyles(styles),
	AuthUserContainer,
	TmwApi
])(InvoiceSearch);
